module.exports = __webpack_public_path__ + "img/wp-existing-habit-card3.eb534fca.jpg";